export default __webpack_public_path__ + "static/rsz_dagna2-5e848493b40388d933606f1cf0eb78ca.jpg";